import { Link } from "react-router-dom";
import SEO from "../components/SEO"; // Add this import
import "./notfound.css";

const NotFound = () => {
  return (
    <>
      {/* Add SEO component with noindex settings */}
      <SEO
        title="Page Not Found - Anjali Daswani Music"
        description="The page you're looking for couldn't be found. Return to Anjali Daswani's music website to discover her latest songs and updates."
        url="https://anjalidmusic.com/404"
        keywords="404 error, page not found, Anjali Daswani"
        robots="noindex, nofollow" // This prevents search engines from indexing this page
      />

      <div className="not-found-page">
        <div className="container">
          <div className="not-found-content">
            {/* 404 Visual */}
            <div className="error-visual">
              <div className="error-number">404</div>
              <div className="broken-waveform">
                <div className="wave-bar broken"></div>
                <div className="wave-bar broken"></div>
                <div className="wave-bar broken"></div>
                <div className="wave-bar broken"></div>
                <div className="wave-bar broken"></div>
              </div>
            </div>

            {/* Error Message */}
            <div className="error-message">
              <h1>Page Not Found</h1>
              <p>
                The page you're looking for seems to have hit a wrong note.
                Let's get you back to the music.
              </p>

              <div className="error-actions">
                <Link to="/" className="btn-primary">
                  Back to Home
                </Link>
                <Link to="/music" className="btn-secondary">
                  Explore Music
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
